var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VOverlay',{attrs:{"value":_vm.loading,"z-index":_vm.zIndex,"opacity":_vm.opacity,"color":_vm.color}},[_c('VProgressCircular',{attrs:{"indeterminate":"","size":"64","color":_vm.loadingColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }